import { render, staticRenderFns } from "./ProfilePayoutBalanceBlock.vue?vue&type=template&id=a3aaf6da"
import script from "./ProfilePayoutBalanceBlock.vue?vue&type=script&lang=js"
export * from "./ProfilePayoutBalanceBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports